module.exports = __webpack_public_path__ + "static/media/banner.b56f4322.jpg";